import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import MainComponent from '../components/MainComponent';
import templateServices from '../services/TemplateServices';
import _ from 'lodash';
import tncChecker from '../common/decorator/tncChecker';
import validPageChecker from '../common/decorator/validPageChecker';
import MemberServices from '../services/MemberService';
import { GROUP_SPORT_PERIODS } from '../common/Foundation';
import withRouter from "../common/decorator/withRouter";
import { translate } from 'react-i18next';
import listenPostMessage from '../common/decorator/listenPostMessage';
import Utils from '../common/Utils';

@tncChecker()
@translate()
@validPageChecker()
@listenPostMessage
@inject('LayoutTemplateStore', 'SportsStore', 'AccountStore')
@observer
@withRouter
export default class MbDynamicBody extends Component {
    
    constructor(props) {
        super(props);
        this.LayoutTemplateStore = this.props.LayoutTemplateStore;
        this.fetchPeriodsDesc = this.fetchPeriodsDesc.bind(this);
         if(this.LayoutTemplateStore.currentPageContainer !== this.props.pageContainer){
            this.LayoutTemplateStore.updateCurrentPageContainer(this.props.pageContainer);
            this.updateTemplateByPage();
            if (this.LayoutTemplateStore.currentViewContainer === 'asiaView') {
              window.scrollTo(0, 0);
            }
         }
    }
    
    componentDidMount() {
      this.fetchPeriodsDesc();
        this.props.history.listen(location => {
            this.viewAction(location);
        });
    }
    
    componentDidUpdate(prevProps){
     if(prevProps.lng !== this.props.lng){
      this.fetchPeriodsDesc();
     }
    }

    fetchPeriodsDesc() {
      MemberServices.getSportPeriodDesc().then(res => {
        const periodData = res.data;
        this.props.AccountStore.updateSuspendedByBotDetector(false);
        this.props.AccountStore.updateMaintenance(false);
        const periodsDesc = Utils.convertPeriodDescriptionData(periodData);
        this.props.SportsStore.updatePeriodDesc(periodsDesc);
        if (Utils.getCurrentLang() === "en") {
          this.props.SportsStore.updateDefaultPeriodDesc(periodsDesc);
        }
      }).catch(error=>{
        const { response } = error
        if (Number(response.status) > 200) {
          if (Number(response.data.code) === 403) {
            this.props.AccountStore.updateSuspendedByBotDetector(true)
          } else {
            this.props.AccountStore.updateMaintenance(true)
          }
        }
      })
    }


    viewAction = (location) => {
        if (location) {
            let strUrl = location.pathname + "";
            let viewName = templateServices.getViewName(strUrl);
            if (viewName !== this.props.LayoutTemplateStore.currentViewContainer) {
                this.props.LayoutTemplateStore.updateCurrentViewContainer(viewName);
              
            }
        }

    }

    updateTemplateByPage = () => {
        let isUseMasterLayout = templateServices.isThisPageUseMasterLayout(this.props.LayoutTemplateStore.templateData, this.props.LayoutTemplateStore.currentViewContainer, this.props.LayoutTemplateStore.currentPageContainer)
         if (isUseMasterLayout !== this.props.LayoutTemplateStore.isUseMasterLayout) {
            this.props.LayoutTemplateStore.updateIsUseMasterLayout(isUseMasterLayout); 
         }
    }
        
    render(){
      const { currentViewContainer, currentPageContainer } = this.props.LayoutTemplateStore;
      const key = currentViewContainer === 'asiaView' ? currentPageContainer : this.props.match.url;
      const router = {
        match: this.props.match,
        history: this.props.history,
        location: this.props.location,
      }
      return (
        <MainComponent
          key={key}
          className="MainComponent"
          router={router}
        />
      );
  }
}


// WEBPACK FOOTER //
// ./src/app/pages/MbDynamicBody.js